import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Zap, ArrowRight } from "lucide-react";

/*  New Live Mystery Arena hero — repositions the brand away from
    "just murder mystery" toward the broader Live Social Thriller platform.
    Renders at the top of the homepage. Fetches the live pack catalog so
    the headline buttons never drift from the actual prices.
*/

const ArenaHero = () => {
  const [packs, setPacks] = useState([]);

  useEffect(() => {
    api.get("/packs")
      .then((r) => setPacks(r.data?.packs || []))
      .catch(() => {});
  }, []);

  const solo = packs.find((p) => p.id === "solo_drop");
  const crew = packs.find((p) => p.id === "crew_pack");

  return (
    <section className="relative overflow-hidden"
      data-testid="arena-hero">
      {/* ambient grain + vignette layers — reuse the cinematic 35mm feel */}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_50%_30%,rgba(139,0,0,0.18),transparent_60%)]" />
      <div className="hero-vignette" aria-hidden="true" />
      <div className="hero-grain" aria-hidden="true" />

      <div className="relative max-w-5xl mx-auto px-5 py-20 sm:py-28 text-center">
        <div className="text-[10px] tracking-[0.4em] text-[#8b0000] mb-5 transmission-pulse"
          data-testid="arena-hero-eyebrow">
          ● LIVE MYSTERY ARENA
        </div>

        <h1 className="font-display text-5xl sm:text-7xl text-[#f4f0ec] leading-[1.05]"
          data-testid="arena-hero-headline">
          Everybody knows <span className="text-[#d4af37]">something.</span>
          <br />
          Nobody knows <span className="text-[#8b0000]">everything.</span>
        </h1>

        <p className="text-[#a39797] text-base sm:text-lg mt-6 max-w-2xl mx-auto">
          Live social thrillers. Secrets. Betrayals. Crews. Rankings.
        </p>

        <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap mt-10">
          {solo && (
            <Link to="/packs"
              className="px-5 py-3 border border-[#2d2424] text-[#f4f0ec] hover:border-[#d4af37] hover:text-[#d4af37] transition-colors text-xs sm:text-sm tracking-[0.2em]"
              data-testid="arena-hero-solo-cta">
              <Zap size={11} className="inline mr-1.5" />
              GET SOLO DROP · {solo.price_label}
            </Link>
          )}
          {crew && (
            <Link to="/packs"
              className="px-6 py-3 bg-[#d4af37] text-black hover:bg-[#f4f0ec] transition-colors text-xs sm:text-sm tracking-[0.2em] font-bold shadow-[0_0_20px_rgba(212,175,55,0.3)]"
              data-testid="arena-hero-crew-cta">
              <Zap size={11} className="inline mr-1.5" />
              GET CREW PACK · {crew.price_label} <span className="opacity-75 ml-1">★</span>
            </Link>
          )}
          <Link to="/packs"
            className="px-5 py-3 border border-[#2d2424] text-[#a39797] hover:border-[#5a5050] hover:text-[#f4f0ec] transition-colors text-xs sm:text-sm tracking-[0.2em]"
            data-testid="arena-hero-all-cta">
            VIEW ALL PACKS <ArrowRight size={11} className="inline ml-1" />
          </Link>
        </div>

        <div className="text-[10px] tracking-[0.3em] text-[#5a5050] mt-8"
          data-testid="arena-hero-subcta">
          INSTANT ACCESS · PLAY WITH FRIENDS · NO WAITING
        </div>
      </div>
    </section>
  );
};

export default ArenaHero;
